import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { CircularProgress, FormControl } from '@mui/material';
import { useEffect, useState } from 'react';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function MultiSelect(props: any) {
  const { propName, disabled, label, options } = props;
  const [selected, setSelected] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState<any>(false);
  const [top100Films, setTop100Films] = React.useState<any[]>([]);

  useEffect(() => {
    setTop100Films([{ title: 'انتخاب همه', year: -1 }, ...(options || [])]); // اضافه کردن گزینه "انتخاب همه"
    setLoading(props.isLoading);
  }, [props]);

  useEffect(() => {
    if (props.initialValues) {
      setSelected(
        props.initialValues.map((item: any) =>
          options.find((option: any) => option.year === item.year) || item
        )
      );
    }
  }, [props.initialValues, options]);

  const initialSelectItem = (value: any) => {
    let { onChangee } = props;

    const isSelectAll = value.some((item: any) => item.year === -1); // بررسی انتخاب "انتخاب همه"

    if (isSelectAll) {
      if (value.length === 1 || value.length !== top100Films.length) {
        // انتخاب تمام آیتم‌ها (به جز "انتخاب همه")
        setSelected(top100Films.slice(1));
        onChangee(propName, top100Films.slice(1).map((item) => item.year));
      } else {
        // لغو تمام انتخاب‌ها
        setSelected([]);
        onChangee(propName, []);
      }
    } else {
      setSelected(value);
      onChangee(propName, value.map(({ year }: any) => year));
    }
  };

  return (
    <FormControl fullWidth sx={{ padding: '8px' }}>
      <Autocomplete
        multiple
        size="small"
        id="checkboxes-tags-demo"
        options={top100Films}
        disableCloseOnSelect
        value={selected}
        disabled={disabled}
        onChange={(e: any, value: any) => {
          initialSelectItem(value);
        }}
        getOptionLabel={(option) => option?.title || ''}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 2 }}
              checked={selected}
            />
            {option?.title}
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? <CircularProgress color="info" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </FormControl>
  );
}
